import { AnySoaRecord } from 'dns'
import React, {useState, useEffect, createContext} from 'react'
import { useTenantStore } from '../Store/permissionStore'
 
type GlobalContextProviderProps = {
    children: React.ReactNode
}
 
type TypeContextType = {
    isRightMenuOpen: any
    setRightMenu: React.Dispatch<any>
 
    tenantName: any
    setTenantName: React.Dispatch<any>
 
    isRole: any
    setRole: React.Dispatch<any>
 
    dartNo: any
    setDartNo: React.Dispatch<any>
 
    selectedRowIdInTable: any
    setSelectedRowIdInTable: React.Dispatch<any>
 
    selectedRowIdInSubTable: any
    setSelectedRowIdInSubTable: any
 
    automationDetails: any
    setAutomationDetails: any
 
    selectedRowDetails: any
    setSelectedRowDetails: React.Dispatch<any>

    selectedAssetRow:any
    setSelectedAssetRow:React.Dispatch<any>
 
    userSessionDetails: any
    setUserSessionDetails: React.Dispatch<any>

    assignmentType: string
    setAssignmentType: React.Dispatch<any>

    loadTableData: boolean
    setLoadTableData: React.Dispatch<any>

    tableColumnsData: any
    setTableColumnsData: React.Dispatch<any>

    filterColumnsData: any
    setFilterColumnsData: React.Dispatch<any>

    manageViewDropDownData: any
    setManageViewDropDownData: React.Dispatch<any>

    manageViewPageDetails: any
    setManageViewPageDetails: React.Dispatch<any>

    logedInFrom: any
    setLogedInFrom: React.Dispatch<any>

    filterData: any
    setFilterData: React.Dispatch<any>
}
 
export const GlobalContext = createContext<TypeContextType | null>(null);
 
export const GlobalContextProvider = ({children}: GlobalContextProviderProps) => {
    const { tenant } = useTenantStore();
    let userDetails: any = JSON.parse(localStorage.getItem('userDetails') ?? '{}');
    userDetails = userDetails?.userid !== undefined ? userDetails : {
        userid: '',
        firstName: '',
        lastName: '',
        user_email: '',
        formDataEdit: '{}',
        rawData:'{}'
    };
   
    var tempAutomationDetails: any = localStorage.getItem('automationDetails');
    tempAutomationDetails = tempAutomationDetails != undefined ? JSON.parse(tempAutomationDetails) : '';
   
    var tempID: any = tempAutomationDetails?.automationID;
    var automationID = (tempID != undefined) ? tempID : 0;

    var tempName: any = tempAutomationDetails?.automationName;
    var automationName = (tempName != undefined && tempName.length > 0) ? tempName : '';
 
    var tempType: any = tempAutomationDetails?.automationType;
    var automationType = (tempType != undefined && tempType.length > 0) ? tempType : '';

    let tempAssignmentType = localStorage.getItem('assignmentType');
    tempAssignmentType = tempAssignmentType ?? '';
 
    var dartno: any = localStorage.getItem('dartNo');
    dartno = (dartno != undefined && dartno.length > 0) ? parseInt(dartno) : 0;
 
    var Role: any = sessionStorage.getItem('role');
    Role = (Role != undefined || Role != "") ? (Role) : "";
    console.log("1tenant-",tenant);
    console.log("2tenant-",typeof tenant);
    console.log("3tenant-",tenant?.length);
    console.log("4tenant-",localStorage.getItem('tenant') );
 
    const [isRightMenuOpen, setRightMenu] = useState<TypeContextType | any>(false);
    // const [tenantName, setTenantName] = useState<TypeContextType | any>(tenant?.length > 0 ? tenant : localStorage.getItem('tenant') ? localStorage.getItem('tenant') : '');
    const [tenantName, setTenantName] = useState<TypeContextType | any>(tenant);
    const [dartNo, setDartNo] = useState<TypeContextType | any>(dartno); // for all_automation page
    // const [userName, setUserName] = useState<TypeContextType | any>('admin'); //need to get it on sign page
    const [isRole, setRole] = useState<TypeContextType | any>(Role);
    const [selectedRowIdInTable, setSelectedRowIdInTable] = useState<TypeContextType | any>([]);
    const [selectedRowIdInSubTable, setSelectedRowIdInSubTable] = useState<TypeContextType | any>([]);

    const [selectedAssetRow, setSelectedAssetRow] = useState<TypeContextType | any>(localStorage.getItem('selectedAssetOrEventQuery') ?? '');
    // const [userEmail, setUserEmail] = useState<TypeContextType | any>({
    const [userSessionDetails, setUserSessionDetails] = useState<TypeContextType | any>({
        userId: userDetails.userid,
        userName: userDetails.firstName,
        userLName: userDetails.lastName,
        userEmail: userDetails.user_email,
        otherDetails: JSON.parse(userDetails.formDataEdit),
        rawData: userDetails.rawData
    });
    const [automationDetails, setAutomationDetails] = useState<TypeContextType | any>({
        automationID: automationID,
        automationName: automationName,
        automationType: automationType,
    });
    const [selectedRowDetails, setSelectedRowDetails] = useState<TypeContextType | any>({
        id: '',
        name: '',
    });
    const [assignmentType, setAssignmentType] = useState(tempAssignmentType);
    const [loadTableData, setLoadTableData] = useState(true);
    const [tableColumnsData, setTableColumnsData] = useState(JSON.parse(localStorage.getItem("tableColumnsData")) ?? {});
    const [filterColumnsData, setFilterColumnsData] = useState({});
    const [manageViewDropDownData, setManageViewDropDownData] = useState([]);
    const [manageViewPageDetails, setManageViewPageDetails] = useState({});
    const [logedInFrom, setLogedInFrom] = useState(JSON.parse(localStorage.getItem("LogedInFrom")) ?? {});
    const [filterData, setFilterData] = useState<TypeContextType | any>('');
    return (<GlobalContext.Provider value={{
        isRightMenuOpen,
        setRightMenu,
        tenantName,
        setTenantName,
        dartNo,
        setDartNo,
        isRole,
        setRole,
        selectedRowIdInTable,
        selectedAssetRow,
        setSelectedAssetRow,
        setSelectedRowIdInTable,
        selectedRowIdInSubTable,
        setSelectedRowIdInSubTable,
        automationDetails,
        setAutomationDetails,
        selectedRowDetails,
        setSelectedRowDetails,
        userSessionDetails,
        setUserSessionDetails,
        assignmentType,
        setAssignmentType,
        loadTableData,
        setLoadTableData,
        tableColumnsData,
        setTableColumnsData,
        filterColumnsData,
        setFilterColumnsData,
        manageViewDropDownData, 
        setManageViewDropDownData,
        manageViewPageDetails,
        setManageViewPageDetails,
        logedInFrom,
        setLogedInFrom,
        filterData,
        setFilterData
    }} >{children}</GlobalContext.Provider>)
}